import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Modal } from 'flowbite';
import { IRoadmapDocumentVersion } from 'src/app/models';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';
import moment from 'moment';

@Component({
    selector: 'app-modal-download-roadmap',
    templateUrl: './modal-download-roadmap.component.html',
    standalone: false
})
export class ModalDownloadRoadmapComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() loading = false;
  @Input() set versions(versions: IRoadmapDocumentVersion[]) {
    this.availableVersions = versions || [];
    this.selectedVersion = this.availableVersions.length ? this.availableVersions[0].version : null;
  }
  @Output() action = new EventEmitter<{ date: string; version: number }>();
  @Output() dateChange = new EventEmitter<string>();

  public images = images;
  public moment = moment;

  public date: string = moment().format('YYYY-MM-DD');
  public availableVersions: IRoadmapDocumentVersion[] = [];
  public selectedVersion: number | null = null;

  constructor(public literalService: LiteralService) {}

  changeDate = (date: any) => {
    this.date = moment(date.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    this.dateChange.emit(this.date);
  };

  onSubmit = () => {
    if (this.selectedVersion === null) return;
    this.action.emit({ date: this.date, version: this.selectedVersion });
  };
}
